/* ══════════════════════════════════════════════════════════════════
   EB MOTION —— 全站唯一的动效运行时。
   两件事：1) section 进场  2) 给后面的 section 提供共享的观察器和帧循环，
   这样二十个 section 不会各建二十个 IntersectionObserver 和 rAF。

   之后写 section 时用：
     EB.motion.inView(el, fn)         元素进入视口触发一次
     EB.motion.watch(el, fn)          持续跟随滚动（共享一个 rAF）
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var disabled = document.body.classList.contains('eb-animations-disabled') || reduce.matches;

  /* ── 共享观察器 ─────────────────────────────────────────────── */
  var callbacks = new WeakMap();
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var fn = callbacks.get(entry.target);
          if (fn) fn(entry.target, entry);
          io.unobserve(entry.target);
          callbacks.delete(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 })
    : null;

  function inView(el, fn) {
    if (!el) return;
    if (!io) { fn(el); return; }
    callbacks.set(el, fn);
    io.observe(el);
  }

  /* ── 共享帧循环。滚动联动效果统一挂这里。 ─────────────────────── */
  var watchers = [];
  var ticking = false;

  function tick() {
    var y = window.scrollY;
    var h = window.innerHeight;
    for (var i = 0; i < watchers.length; i++) {
      var w = watchers[i];
      var r = w.el.getBoundingClientRect();
      if (r.bottom < -200 || r.top > h + 200) continue;
      w.fn(w.el, { rect: r, scrollY: y, viewportH: h, progress: 1 - (r.top + r.height) / (h + r.height) });
    }
    ticking = false;
  }
  function request() { if (!ticking) { ticking = true; window.requestAnimationFrame(tick); } }

  function watch(el, fn) {
    if (!el || disabled) return function () {};
    watchers.push({ el: el, fn: fn });
    request();
    return function () {
      watchers = watchers.filter(function (w) { return w.el !== el; });
    };
  }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', request, { passive: true });

  /* ── 命名效果注册表。section 自带的动效挂名字，不污染全局。 ────── */
  var effects = {};
  function register(name, fn) { effects[name] = fn; }
  function mountEffects(root) {
    (root || document).querySelectorAll('[data-eb-motion]').forEach(function (el) {
      if (el.dataset.ebMotionReady === '1') return;
      var fn = effects[el.getAttribute('data-eb-motion')];
      if (!fn) return;
      el.dataset.ebMotionReady = '1';
      fn(el, { inView: inView, watch: watch, disabled: disabled });
    });
  }

  /* ── section 进场 ───────────────────────────────────────────── */
  function stagger(group) {
    var step = parseFloat(getComputedStyle(group).getPropertyValue('--reveal-stagger')) || 70;
    var kids = group.children;
    for (var i = 0; i < kids.length; i++) {
      kids[i].style.setProperty('--reveal-delay', Math.min(i, 6) * step + 'ms');
    }
  }

  function mountReveal(root) {
    (root || document).querySelectorAll('[data-reveal], [data-reveal-group]').forEach(function (el) {
      if (el.classList.contains('is-revealed')) return;
      if (disabled) { el.classList.add('is-revealed'); return; }
      inView(el, function (target) {
        if (target.hasAttribute('data-reveal-group')) stagger(target);
        target.classList.add('is-revealed');
      });
    });
  }

  function mount(root) { mountReveal(root); mountEffects(root); }

  mount();
  document.addEventListener('shopify:section:load', function (e) { mount(e.target); });

  /* ── 一次性扫光 ────────────────────────────────────────────────
     `EB.sheen(el)` —— 「刚发生了一件事」的那一下：加入购物车、复制成功、
     价格更新。⚠️ **绝不循环**：循环的扫光是廉价感唯一的来源，
     它只能由一个事件触发，放一次，然后自己收拾干净。

     样式在 base.css 的 `.eb-sheen`，reduced-motion 下整组关掉 ——
     它是氛围，不是信息，关了不丢任何东西。 */
  function sheen(el) {
    if (!el || disabled()) return;
    el.classList.add('eb-sheen');
    /* 已经在跑就先摘掉，否则连点两下第二下不会重放 */
    el.removeAttribute('data-sheen');
    void el.offsetWidth;
    el.setAttribute('data-sheen', '');
  }
  /* 动画在 ::after 上，animationend 冒泡上来时 target 就是宿主元素 */
  document.addEventListener('animationend', function (e) {
    if (e.animationName === 'eb-sheen' && e.target && e.target.removeAttribute) {
      e.target.removeAttribute('data-sheen');
    }
  });

  window.EB = window.EB || {};
  window.EB.motion = {
    inView: inView,
    watch: watch,
    register: register,
    mount: mount,
    disabled: disabled,
    sheen: sheen
  };
  window.EB.sheen = sheen;
})();
